export const PlatformErrors = {
  OUTDATED_VERSION: "outdated-version",
} as const;

type PlatformError = (typeof PlatformErrors)[keyof typeof PlatformErrors];

/* Checks for specific errors that have special cases */
export const getPlatformErrorType = (error: Error): PlatformError | null => {
  try {
    if (
      error.name === "ChunkLoadError" ||
      error.message.includes("Failed to fetch dynamically imported module")
    ) {
      return PlatformErrors.OUTDATED_VERSION;
    }
    return null;
  } catch {
    return null;
  }
};

export const isPlatformError = (error: Error) => {
  return Boolean(getPlatformErrorType(error));
};
